"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getElementBySelector = function (selector, parent) {
    if (parent === void 0) { parent = document; }
    return parent.querySelector(selector);
};
exports.default = getElementBySelector;
//# sourceMappingURL=getElementBySelector.js.map